import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../api";
import { useCompany } from "../Company/CompanyContext";
import { toast } from "react-toastify";
import { FaTrash, FaPlus } from "react-icons/fa";

function makeId() {
  return `tl_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;
}

export default function TeamLeadersTab({ raw }) {
  const { t } = useTranslation();
  const { reload } = useCompany();
  const [leaders, setLeaders] = useState(() => {
    try { return JSON.parse(raw.team_leaders || "[]"); }
    catch { return []; }
  });
  const [newName, setNewName]   = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [saving, setSaving]     = useState(false);

  const add = () => {
    const name  = newName.trim();
    const email = newEmail.trim();
    if (!name || !email) return;
    setLeaders((l) => [...l, { id: makeId(), name, email }]);
    setNewName("");
    setNewEmail("");
  };

  const remove = (id) => setLeaders((l) => l.filter((x) => x.id !== id));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", { team_leaders: JSON.stringify(leaders) });
      await reload();
      toast.success(t("settings.teamLeaders.saved"));
    } catch {
      toast.error(t("settings.common.saveError"));
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-lg">
      <p className="text-sm text-base-content/60">
        {t("settings.teamLeaders.intro")}
      </p>

      <ul className="space-y-2">
        {leaders.map((l) => (
          <li key={l.id} className="flex items-center gap-2 bg-base-200 rounded-lg px-3 py-2">
            <span className="flex-1 text-sm">
              <span className="font-medium">{l.name}</span>
              <span className="text-base-content/50 ml-2">{l.email}</span>
            </span>
            <button onClick={() => remove(l.id)} className="btn btn-ghost btn-xs text-error px-1" title={t("settings.prestations.remove")}>
              <FaTrash />
            </button>
          </li>
        ))}
        {leaders.length === 0 && (
          <li className="text-sm text-base-content/40 italic">{t("settings.teamLeaders.empty")}</li>
        )}
      </ul>

      <div className="flex gap-2">
        <input
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder={t("settings.teamLeaders.namePlaceholder")}
          className="input input-bordered input-sm flex-1 bg-base-200 border-base-300 focus:border-primary focus:outline-none"
        />
        <input
          type="email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder={t("settings.teamLeaders.emailPlaceholder")}
          className="input input-bordered input-sm flex-1 bg-base-200 border-base-300 focus:border-primary focus:outline-none"
        />
        <button onClick={add} className="btn btn-sm btn-ghost border border-base-300">
          <FaPlus /> {t("settings.prestations.add")}
        </button>
      </div>

      <div className="flex justify-end">
        <button onClick={save} disabled={saving} className="btn btn-primary">
          {saving ? t("settings.prestations.saving") : t("settings.prestations.save")}
        </button>
      </div>
    </div>
  );
}
